import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { applyRouteSeo } from '../../lib/seo';

// Lightweight per-route SEO binder. No UI, no styling changes.
export default function Seo() {
  const location = useLocation();
  const { currentLanguage } = useLanguage();

  useEffect(() => {
    applyRouteSeo(location.pathname, currentLanguage || 'fr');
  }, [location.pathname, currentLanguage]);

  return null;
}
